import React from 'react';

export const Slotted = (props) => {
  return (
    <div>{props.children}</div>
  );
};

Slotted.displayName = 'Slotted';
